import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { BsExclamationLg } from "react-icons/bs";
import { FaBan } from "react-icons/fa6";
import { formatNumberWithCommas } from "../../../utils/commonUtils";
import { cancelManualTransfer, fetchManualTransfer } from "../../../redux/slices/manualTransferSlice";
import { pushNotifyUser } from "../../../redux/slices/pushSlice";

export default function CancelPersonalizeShoppingManualTransfer({
  id,
  name,
  amount,
  user_id,
}) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const status = useSelector((state) => state.payment?.status);

  const dispatch = useDispatch();

  const handleCancel = async () => {
    try {
      const res = await dispatch(cancelManualTransfer(id)); // <-- Cancel action
      if (res.payload) {
        const pushNote = {
          user_id: [user_id],
          title: "Capfields Evolve",
          body: `Your manual payment of ₦${amount} has been declined. Kindly verify and try again.`,
          click: "USER",
        };
        dispatch(pushNotifyUser(pushNote));
        await dispatch(fetchManualTransfer());
        toast.success(res.payload.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to cancel the manual transfer.");
    }
    setShowCancelModal(false);
  };

  return (
    <>
      <div className="flex items-center">
        <button type="button" onClick={() => setShowConfirmModal(true)}>
          <FaBan className="text-red-600 text-xl" />
        </button>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <>
          <div className="fixed inset-0 z-50 flex justify-center items-center">
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full relative">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              >
                <FaTimes />
              </button>
              <div className="text-center">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  Are you sure?
                </h2>
                <p className="text-sm text-gray-600">
                  Do you really want to cancel this manual payment?
                </p>
                <div className="my-4">
                  <BsExclamationLg className="text-3xl text-gray-500 mx-auto" />
                </div>
                <div className="flex gap-4 justify-center mt-6">
                  <button
                    onClick={() => setShowConfirmModal(false)}
                    className="text-sm bg-gray-100 text-gray-700 px-4 py-2 rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      setShowConfirmModal(false);
                      setShowCancelModal(true);
                    }}
                    className="text-sm bg-red-600 text-white px-4 py-2 rounded-md"
                  >
                    Yes, Cancel Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}

      {/* Cancel Modal */}
      {showCancelModal && (
        <>
          <div className="fixed inset-0 z-50 flex justify-center items-center">
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-lg w-full relative">
              <button
                onClick={() => setShowCancelModal(false)}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              >
                <FaTimes />
              </button>
              <div className="text-center">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">
                  Cancel Manual Transfer
                </h2>
                <p className="text-sm text-gray-600">
                  Do you really want to cancel this transfer?
                </p>
                <div className="my-4">
                  <BsExclamationLg className="text-3xl text-gray-500 mx-auto" />
                </div>
                <div className="text-left mt-4 space-y-2 text-sm text-gray-700">
                  <p>
                    <span className="font-semibold">User Name:</span> {name}
                  </p>
                  <p>
                    <span className="font-semibold">Amount:</span> ₦
                    {formatNumberWithCommas(amount)}
                  </p>
                </div>
                <div className="flex gap-4 justify-center mt-6">
                  <button
                    onClick={() => setShowCancelModal(false)}
                    className="text-sm bg-gray-100 text-gray-700 px-4 py-2 rounded-md"
                  >
                    Close
                  </button>
                  <button
                    onClick={handleCancel}
                    disabled={status === "loading"}
                    className="flex gap-2 items-center bg-red-600 text-white px-4 py-2 rounded-md"
                  >
                    {status === "loading" ? (
                      <>
                        <FaSpinner className="animate-spin" />
                        Cancelling...
                      </>
                    ) : (
                      <>
                        <FaTimes />
                        Cancel Payment
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}
    </>
  );
}
